/**
 * CampaignTextBlock - styles
 */

import styled, { css } from 'styled-components';
import { px2rem } from 'theme/utils';
import { colors, typography, mediaQueries } from 'theme';
import { H1, Preamble } from 'components/Text/Text.styles';

export interface ThemeProps {
	headingAlignment?: 'left' | 'center';
	blockAlignment?: 'left' | 'center';
	backgroundColor?: 'lightBlue' | 'white' | 'transparent';
}

export interface BlockProps {
	blockAlignment?: 'left' | 'center';
}

const commonStyle = css`
	color: ${colors.black};
	font-family: ${typography.fontFamily.alt};
	font-size: ${typography.baseFontSize};
`;

export const WrapperContainer = styled.div<ThemeProps>`
	${({ backgroundColor }) => {
		if (backgroundColor === 'lightBlue') {
			return `
				background-color: ${colors.blueLightest};
			`;
		} else {
			return `
			background-color: ${colors.white};
			`;
		}
	}}
`;

export const Container = styled.div<ThemeProps>`
	${commonStyle};
	display: flex;
	flex-direction: column;
	max-width: 51rem;
	padding: 15px;
	margin: 0 auto;

	${mediaQueries.phone} {
		padding: 20px;
	}

	${mediaQueries.tablet} {
		max-width: 42rem;
	}

	background-color: ${({ backgroundColor }) =>
		backgroundColor === 'lightBlue'
			? colors.blueLightest
			: backgroundColor === 'transparent'
			? 'transparent'
			: colors.white};

	align-items: ${({ blockAlignment }) =>
		blockAlignment === 'left' ? 'start' : 'center'};
`;

export const TextContainer = styled.div`
	${commonStyle};
	align-items: left;
	text-align: left;
	max-width: ${px2rem(788)};

	${mediaQueries.tablet} {
		max-width: ${px2rem(645)};
	}

	p {
		font-weight: ${typography.fontWeight.normal};
		font-size: ${typography.baseFontSize};
	}
`;

export const StyledPreamble = styled(Preamble)`
	margin: 0 0 3.5rem;
	font-weight: ${typography.fontWeight.medium} !important;
`;

export const Heading = styled(H1)<ThemeProps>`
	${commonStyle};
	font-weight: ${typography.fontWeight.bold};
	padding-top: 1.2rem;
	margin-top: 1rem;
	margin-bottom: 1rem;
	text-align: ${({ headingAlignment }) =>
		headingAlignment === 'left' ? 'left' : 'center'};
`;
